module.exports = __webpack_public_path__ + "img/frame-2.25f5a7bf.svg";